import { Navigate } from "react-router-dom";
import { useSubscription } from "../hooks/useSubscription";
import { usePermissions } from "../hooks/usePermissions";
import PropTypes from "prop-types";

const ProtectedRouteWithSubscription = ({ permission, element, check }) => {
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();

  if (check === "either_or_reversed" && hasPermission(permission, "eitherOr")) {
    return element;
  } else if (!hasSubscription(permission)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return element;
};

ProtectedRouteWithSubscription.propTypes = {
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  element: PropTypes.node,
  check: PropTypes.string,
};

export default ProtectedRouteWithSubscription;
